var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".accddee{fill:#0071b9;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-509 -465)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.2,16.04l-1.4,1.332s-4.355,4.143-4.355,4.143l-.066-.069.065.07a1.931,1.931,0,0,1-2.733-.069L10.128,20.1l4.342-4.129Zm1.679-2.888L11.441,6.2a1.932,1.932,0,0,0-2.732.093L10.115,7.6c.006.007,5.656,5.29,5.656,5.29H1.932a.967.967,0,0,0,0,1.934H18.221a.967.967,0,0,0,.66-1.673Z",
    transform: "translate(511.035 463.324)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24,
    transform: "translate(509 465)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsRightArrow);
export default __webpack_public_path__ + "static/media/icons-right-arrow.870a4a78.svg";
export { ForwardRef as ReactComponent };